import React from "react";
import submit from "submit-form";

class FaqComponent extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      isOpen: false,
    };
  }

  toggleAnswer() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  toggleEdit() {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "edit-faq",
        id: this.props.index,
      },
    });
  }

  removeQuestion() {
    submit("#_", {
      method: "POST",
      body: {
        isRemoving: true,
        id: this.props.index,
      },
    });
  }

  render() {
    const { question = "", answer = "", isDefault = false } = this.props;
    const { isOpen } = this.state;
    return (
      <li className="question">
        <article
          className="bar"
          onClick={() => {
            this.toggleAnswer();
          }}
        >
          <header>
            <p className="s1">{question}</p>
            <img
              alt="open"
              src={`/img/new-icons/arrow-square-${isOpen ? "up" : "down"}.svg`}
            />
          </header>
          {isOpen && <p className="p2">{answer}</p>}
        </article>
        {!isDefault && (
          <div className="action-buttons">
            <button data-button-type="secondary" data-icon data-icon-only>
              <img
                alt="edit"
                src="/img/new-icons/edit-pencil.svg"
                className="icon-yellow pen"
                onClick={() => {
                  this.toggleEdit();
                }}
              />
            </button>
            <button data-button-type="secondary" data-icon data-icon-only>
              <img
                alt="delete"
                src="/img/new-icons/red-trash.svg"
                className="icon-red"
                onClick={() => {
                  this.removeQuestion();
                }}
              />
            </button>
          </div>
        )}
      </li>
    );
  }
}

export default FaqComponent;
